import React from "react";
import "./style.scss";
import { NavLink } from "react-router-dom";
import { FaEnvelope, FaHome, FaFolder, FaTasks } from "react-icons/fa";
import PropTypes from "prop-types";

const Header = (props) => {
  return (
    <header className="header">
      <nav>
        <div className="logo">
          <NavLink to="/">
            {props.firstName}
            <span>{props.lastName}</span>
          </NavLink>
        </div>
        <input type="checkbox" id="menu-toggle" />
        <label htmlFor="menu-toggle" className="menu-icon">
          <span></span>
          <span></span>
          <span></span>
        </label>
        <ul className="menu">
          <li className="FaH">
            <FaHome />
            <NavLink to="/">Home</NavLink>
          </li>
          <li className="FaT">
            <FaTasks />
            <NavLink to="/competences">Competences</NavLink>
          </li>
          <li className="FaF">
            <FaFolder />
            <NavLink to="/portfolio">Portfolio</NavLink>
          </li>
          <li className="navbar-btn">
            <FaEnvelope />
            <NavLink to="/contact">Contact</NavLink>
          </li>
        </ul>
      </nav>
    </header>
  );
};

Header.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
};

export default Header;